<template>
  <div>
        <ctop />
        <cswiper />
        <search />
        <div class="c_content">
            <div class="crumbs">
                <div class="border"></div>
                <div class="now">当前位置：</div>
                <div class="one"> 方案定制 </div>
            </div>

            <div class="q_content_name">一站式服务，轻松便捷</div>
            <div class="q_content">
                
                <div class="content_l">
                    <div class="user_info">
                        <div class="top">
                            <img src="~@/assets/laba.png">
                            <span>为了方便官网客服或者专员联系您，请输入您的个人信息，您的私人信息全部保密</span>
                        </div>
                        <div class="user_content">
                            <div class="user_name">
                                <span>您的称呼：</span>
                                <input v-model="form.name">
                            </div>
                            <div class="user_name">
                                <span>联系电话：</span>
                                <input type="text" v-model="form.phone">
                            </div>
                            <div class="user_name">
                                <span>性别：</span>
                                <el-radio v-model="form.sex" label='1'>男</el-radio>
                                <el-radio v-model="form.sex" label='2'>女</el-radio>
                            </div>
                            
                        </div>
                    </div>


                    <div class="case_info">
                        <div class="top">
                            <img src="~@/assets/laba.png">
                            <span>预算节省10%，提交需求后，5分钟内官网客服或者专员联系您</span>
                        </div>
                        <div class="user_content">
                            <div class="user_name">
                                <span>方案名称：</span>
                                <input type="text" v-model="form.entrustname">
                            </div>
                            <div class="user_name">
                                <span>方案类型：</span>
                                <!-- <input type="text" value=""> -->
                                <el-select v-model="form.columns" placeholder="请选择" @change="getdefaults($event)">
                                    <el-option
                                    v-for="item in columns"
                                    :key="item.name"
                                    :value="item.name">
                                    </el-option>
                                </el-select>
                            </div>
                            <div class="user_name">
                                <span>方案种类：</span>
                                <el-select v-model="form.columns2" placeholder="请选择">
                                    <el-option
                                    v-for="item in columns2"
                                    :key="item.name"
                                    :value="item.name">
                                    </el-option>
                                </el-select>
                            </div>
                            <div class="user_name">
                                <span>活动预算：</span>
                                <el-select v-model="form.columns3" placeholder="请选择">
                                    <el-option
                                    v-for="item in columns3"
                                    :key="item.name"
                                    :value="item.name">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                    </div>

                    <div class="des_info">
                        <div class="top">
                            <img src="~@/assets/laba.png">
                            <span>您还有什么需要补充或者说明的，请填写在下面框</span>
                        </div>
                        <div class="user_content">
                            <div class="user_name">
                                <span>留言备注：</span>
                                <el-input
                                type="textarea"
                                :autosize="{ minRows: 2, maxRows: 4}"
                                placeholder="请输入内容"
                                v-model='form.text'>
                                </el-input>
                            </div>
                            
                        </div>
                    </div>

                    <div class="content_l_bottom">
                        <el-button @click="postinfo()">提交</el-button>
                    </div>
                </div>

                <div class="content_r">
                    <div class="top_title">热门推荐</div>
                    <div class="r_list">
                        <div class="list" v-for="(vo,i) of caselist.slice(0,5)" :key="i">
                            <img class="left" :src="$uploadurl + vo.img">
                            <div class="right">
                            <div class="name">{{vo.name}}</div>
                            <div class="des">{{vo.des}}</div>
                            <div class="bottom">

                                <div class="state">
                                    <div class="option">
                                        <img src="~@/assets/play_num.png">
                                        <span>{{vo.click_num}}</span>
                                    </div>
                                    <div class="option">
                                        <img src="~@/assets/collect.png">
                                        <span>{{vo.collect_num}}</span>
                                    </div>
                                    <div class="option">
                                        <img src="~@/assets/zan_ash.png">
                                        <span>{{vo.peck_num}}</span>
                                    </div>
                                </div>
                                
                            </div>
                            </div>
                        </div>

                        
                    </div>
                </div>

            </div>
        </div>


        <bottom />
        <right />
  </div>
</template>

<script>
import ctop from '@/components/ctop'
import cswiper from '@/components/cswiper'
import search from '@/components/search'
import bottom from '@/components/bottom'
import right from '@/components/right'

export default {
  name: 'Home',
  components: {
      cswiper,
      ctop,
      search,
      bottom,
      right
  },
  data () {
    return {
        form:{
            name:"",
            sex:'1',
            phone:'',
            entrustname:'',
            text:'',
            columns:'',
            columns2:'',
            columns3:'',
        },

        currentPage3: 5,

        columns:[
            
        ],
        columns2:[
            
        ],
        columns3:[
            
        ],

        caselist:[]
    }
  },
  computed: {
    
  },
  mounted() {
    this.getinfo()
    this.getcase()
  },
  methods:{
      postinfo(){
          console.log(this.form)
          this.$http.post('/api/entrust/add',this.$qs.stringify({data:this.form,uid:'',username:''})).then((res)=>{
                let callback = res.data
                if(callback.code == 200){
                    this.form = {
                        name:"",
                        sex:'1',
                        phone:'',
                        entrustname:'',
                        text:'',
                        columns:'',
                        columns2:'',
                        columns3:'',
                    }
                    this.$message({
                        message: '提交成功',
                        type: 'success'
                    });
                }else{
                    
                }
            }).catch((error) => {
                console.log('获取失败')
            })
      },
      getdefaults(event){
          console.log(event)
      },
      getcase(){
            this.$http.post('/api/casecontent/index',this.$qs.stringify({id:0})).then((res)=>{
                let callback = res.data
                if(callback.code == 200){
                    this.caselist = callback.data
                    // console.log(this.caselist)
                }else{
                    
                }
            }).catch((error) => {
                console.log('获取失败')
            })
        },
        getinfo(){
            this.$http.get('/api/entrust/option').then((res)=>{
              let callback = res.data.data
                let _this = this
                for (var i = 0; i < callback.length; i++) {
                    
                    if(callback[i].c_type == '1'){
                        _this.columns.push(
                            {
                                'name':callback[i].c_name,
                                'id':i
                            }
                        )
                    }
                    if(callback[i].c_type == '2'){
                        _this.columns2.push(
                            {
                                'name':callback[i].c_name,
                                'id':i
                            }
                        )
                    }
                    if(callback[i].c_type == '3'){
                        _this.columns3.push(
                            {
                                'name':callback[i].c_name,
                                'id':i
                            }
                        )
                    }
                }
            }).catch((error) => {
                console.log('获取失败')
            })
        },
        handleSizeChange(val) {
            console.log(`每页 ${val} 条`);
        },
        handleCurrentChange(val) {
            console.log(`当前页: ${val}`);
        }
  },
  
}
</script>

<style lang="scss" scoped>
$zycolor:#CF2C2E;

.c_content{
    width: 100%;
    padding:0 75px;
    box-sizing: border-box;
}
.crumbs{
    display: flex;
    border-bottom: 1px solid #eee;
    padding: 15px 0;
    align-items: center;
    .border{
        height: 20px;
        width: 5px;
        background: #CF2C2E;
        border-radius: 5px;
        margin:0 20px 0 65px;
    }
    .fu{
        margin:0 5px;
    }
}
.q_content{
    display: flex;
    justify-content: space-between;
    margin-top:80px;
    .content_l{
        width: 70%;
        padding:0 20px 20px 0;
        margin-bottom: 100px;
        box-sizing: border-box;
        .top{
            display: flex;
            flex-wrap:wrap;
        }
        .bottom{
            display: flex;
            justify-content: center;
            flex-direction: column;
            align-items: center;
            margin-top:50px;
            .end{
                display: flex;
                align-items: center;
                .border{
                    width: 40px;
                    height: 1px;
                    background: #222;
                }
                .name{
                    margin:0 30px;
                }
            }
            .wp{
                display: flex;
                flex-direction: column;
                align-items: center;
                margin:30px 0;
                span{
                    margin:10px 0;
                }
            }
            .wechat_code{
                img{
                    margin-bottom: 10px;
                }
            }
        }
        .list:hover{
            .list_content{
                
                animation:1s infinite mymove;
                animation-iteration-count:1;
                animation-fill-mode: forwards;
            }
        }
        @keyframes mymove
        {
            from {box-shadow: 0px 0px 0px rgba(0, 0, 0, 0.16);}
            to {box-shadow: 1px 6px 9px rgba(0, 0, 0, 0.16);}
        }
        .list{
            
            box-sizing: border-box;
            border-radius: 15px;
            // margin-right:20px;
            // flex: 1;
            flex-basis:25%;
            padding:0 15px;
            cursor: pointer;
            .list_content{
                border: 1px solid #e2e2e2;
                border-radius: 15px;
                margin-bottom: 20px;
            }
            .zhu{
                width: 100%;
                height: 250px;
            }
            .name{
                width: 100%;
                text-align: left;
                margin:7px 0 7px 10px;
            }
            .tag{
                margin:5px 0;
                display: flex;
                color: #A1A1A1;
                font-size: 14px;
                margin-left: 10px;
                .t_list{
                    margin-right:10px;
                }
            }
            .state{
				display: flex;
				// margin-top:10px;
				padding:10px 0px 10px 0;
				margin-left: 10px;
				.option{
					display: flex;
					align-items: center;
					margin-right:10px;
					img{
						width: 20px;
						height: 20px;
					}
					span{
						color:#A1A1A1;
						font-size: 14px;
					}
				}
			}
        }
    }
    .content_r{
        width: 30%;
        border-radius: 15px;
        border:1px solid #eee;
        .top_title{
            margin-top:20px;
            font-size: 24px;
        }
        .r_list{
            display: flex;
            flex-direction: column;
            align-items: center;
            margin-top:20px;
            padding:0 20px;
            .list{
                display: flex;
                cursor: pointer;
                border-radius: 15px;
                margin-bottom: 20px;
                width: 100%;
                .left{
                    width: 190px;
                    height: 190px;
                }
            }
            .list:hover{
                animation:1s infinite mymove;
                animation-iteration-count:1;
                animation-fill-mode: forwards;
            }
            .right{
                padding:10px;
                display: flex;
                justify-content: space-between;
                flex-direction: column;
                width: 57%;
                .name{
                    text-align: left;
                    font-size: 18px;
                    font-weight: bold;
                }
                .des{
                    color:#A1A1A1;
                    text-align: left;
                    font-size: 14px;
                    margin-top:5px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 3;
                    -webkit-box-orient: vertical;
                }
            }
            .bottom{
                display: flex;
                .state{
                    display: flex;
                    // margin-top:10px;
                    padding:10px 0px 10px 0;
                    
                    .option{
                        display: flex;
                        align-items: center;
                        margin-right:10px;
                        img{
                            width: 20px;
                            height: 20px;
                        }
                        span{
                            color:#A1A1A1;
                            font-size: 14px;
                        }
                    }
                }
            }
        }
    }
}
.q_content_name{
    margin-top:80px;
    text-align: left;
    color:#222;
    font-size: 30px;
}
.q_content_time{
    text-align: left;
    margin:10px 0;
    color:#A1A1A1;
    span{
        color: #222;
    }
    
}

.user_info ,.case_info ,.des_info{
    border:1px solid #A1A1A1;
    padding:20px;
    .top{
        display: flex;
        align-items: center;
        img{
            width: 20px;
            height: 20px;
        }
        span{
            margin-left: 20px;
        }
    }
}
.case_info ,.des_info{
    margin-top:20px;
}
.user_content{
    margin-top:30px;
    .user_name{
        margin-bottom:20px;
        display: flex;
        align-items: center;
        span{
            width: 120px;
        }
        input{
            border-radius: 20px;
            border:1px solid #707070;
            width: 350px;
            padding:10px 15px;
        }
    }
}
.content_l_bottom{
    margin-top:100px;
    
    button{
        border-radius: 20px;
        background: $zycolor;
        border:$zycolor;
        width: 300px;
        color: #fff;
        font-size: 20px;
    }
}
</style>
